module.exports = __webpack_public_path__ + "img/wild-seed.0cb1738a.png";